import React from 'react';
//import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
//import { ShopperContext } from '../context/shopper';
import { useUtils } from "../hooks/useUtils";
import { formatMoney } from '../utils';
import { useTranslation } from "react-i18next";

export const PriceLink = ( {sku, price, circleIsCurrent} ) => {
  const { toMmmDdYyyy } = useUtils();
  const { t } = useTranslation();

  const currency_symbol  = sku.circle.currency_symbol;
  const currency_subunit = sku.circle.currency_subunit;

  return (
    <tr>
      <td>
        { toMmmDdYyyy({dateString: price.price_date}) }
      </td>

      <td>
        {
          formatMoney({
            currency_symbol,
            currency_subunit,
            amount: price.price,
          })
        }
      </td>

      <td>
        {
          price.discount_amount > 0
            ? formatMoney({
                currency_symbol,
                currency_subunit,
                amount: price.discount_amount
              })
            : t('global.label.noneEntered')
        }
      </td>

      <td>
        {
          price.discount_amount > 0
            ? formatMoney({
                currency_symbol,
                currency_subunit,
                amount: price.price - price.discount_amount
              })
            : null
        }
      </td>

      <td>
        { toMmmDdYyyy({dateString: price.discount_start_date}) }
      </td>

      <td>
        { toMmmDdYyyy({dateString: price.discount_end_date}) }
      </td>

      <td>
        { circleIsCurrent
          ? <Link to={`/skus/${sku.id}/prices/${price.id}`}>
              { t('global.label.edit') }
              {/* Edit */}
            </Link>
          : null
        }
      </td>
    
    </tr>
  )
}

export default PriceLink